import intlTelInput from 'intl-tel-input'

const phoneReplacement = () => {
	const $phone = document.querySelector('input[name="Phone"]')
	if (!$phone) return
	// $phone.style.display = 'none'

	const $newInput = document.createElement('input')
	$newInput.type = 'tel'
	$newInput.autocomplete = 'tel'
	$newInput.classList.add('intl-tel-input')

	$phone.insertAdjacentElement('beforebegin', $newInput)

	const intlTel = intlTelInput($newInput, {
		loadUtils: () => import('intl-tel-input/build/js/utils.js'),
		separateDialCode: true,
		strictMode: true,
		useFullscreenPopup: false,
		initialCountry: 'auto',
		geoIpLookup: (success, failure) => {
			fetch("https://ipapi.co/json")
				.then((res) => res.json())
				.then((data) => success(data.country_code))
				.catch(() => failure());
		}
	})

	// strictMode's paste handler calls preventDefault, which fails Lighthouse
	// paste-preventing-inputs. Capture-phase stop lets native paste through;
	// keydown still blocks non-numeric typing.
	$newInput.addEventListener('paste', (event) => {
		event.stopImmediatePropagation()
	}, true)

	const $countryIso = document.createElement('div')
	$countryIso.classList.add('iti-country-iso')
	document.querySelector('.iti__selected-country-primary').appendChild($countryIso)

	$newInput.addEventListener('input', (e) => {
		$phone.value = intlTel.getNumber()
	})

	$newInput.addEventListener("countrychange", () => {
		const countryIso = intlTel.getSelectedCountryData().iso2
		$countryIso.textContent = countryIso
	})

	document.querySelector('.iti__search-input')
		.addEventListener('input', ({target}) => {
			const targetValue = target.value
			setTimeout(() => {
				const list =
					document.querySelectorAll('.iti__country-container .iti__country-name');
				[...list].forEach((element) => {
					const text = element.textContent;
					const [part1, part2] = text.toLowerCase().split(targetValue.toLowerCase())

					element.innerHTML =
						text.substr(0, part1.length) +
						'<span>' + text.substr(part1.length, targetValue.length) + '</span>' +
						text.substr(part1.length + targetValue.length)
				})
			}, 500)
		})

}

export default phoneReplacement
